import Page from '../components/Page';

export default function Product() {
  return (
    <Page pageId="admin" title={"Admin"}>
      <>To do</>
    </Page>
  );
}